import Icon from "@/components/atoms/icon/Icon";
import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiClose,
  mdiInformationOutline,
} from "@mdi/js";
import type { CSSProperties } from "react";
import classes from "./Toast.module.css";

export type ToastTheme = "main" | "success" | "info" | "neutral" | "warning" | "danger";

interface IToastProps {
  children: React.ReactNode;
  theme?: ToastTheme;
  style?: CSSProperties;
  onClose?: () => void;
}

function getThemeClassName(theme: ToastTheme) {
  if (theme === "main") return classes.ThemeMain;
  if (theme === "success") return classes.ThemeSuccess;
  if (theme === "info") return classes.ThemeInfo;
  if (theme === "neutral") return classes.ThemeNeutral;
  if (theme === "warning") return classes.ThemeWarning;
  if (theme === "danger") return classes.ThemeDanger;
}

function getThemeIcon(theme: ToastTheme) {
  if (theme === "danger") return mdiAlertCircleOutline;
  if (theme === "info") return mdiInformationOutline;
  if (theme === "neutral") return undefined;
  if (theme === "success") return mdiCheck;
  if (theme === "warning") return mdiAlertOutline;
}

export default function Toast({ children, theme = "neutral", style = {}, onClose }: IToastProps) {
  const classNames = [classes.Toast, getThemeClassName(theme)];
  const icon = getThemeIcon(theme);

  return (
    <div className={classNames.join(" ")} data-testid="Toast_wrapper" style={style}>
      {icon ? <Icon d={icon} data-testid="Toast_icon" /> : undefined}
      {children}
      {onClose ? <Icon d={mdiClose} className={classes.Close} onClick={onClose} /> : null}
    </div>
  );
}
